import React, { useContext, useEffect, useRef, useState } from 'react';
import { FuelIcon, FuelTextField } from '@frete.com/fuel-react';
import AppContext from '@context';
import useAmplitude from '@hooks/useAmplitude';
import useDebounce from '@hooks/useDebounce';
import useLoadJourneys from '@hooks/useLoadJourneys';

function FiltersSearch() {
  const {
    state: {
      filters: { search: searchContext },
    },
    dispatch,
  } = useContext(AppContext);
  const [searchValue, setSearchValue] = useState('');

  const { amplitudeEvent } = useAmplitude();
  const { debounce, suspendDebounce } = useDebounce(500);
  const { fetchJourneys } = useLoadJourneys('lazy');

  const searchInput = useRef(null);

  const dispatchSearch = (search = ''): void => {
    dispatch({
      type: 'filter_search_update',
      payload: { search },
    });

    dispatch({
      type: 'filter_search_active',
      payload: { isSearching: search.length > 0 },
    });
  };

  const debouncedApplyTextChange = () => {
    suspendDebounce();
    debounce(() => {
      dispatchSearch(searchValue);
    });
  };

  const getSearchFromEvent = (event: KeyboardEvent | ClipboardEvent) => {
    const target = event.target as HTMLInputElement;

    const { value } = target;

    return value;
  };

  const handleKeyUp = (event: KeyboardEvent): void => {
    event.stopPropagation();

    const search = getSearchFromEvent(event);
    setSearchValue(search);
  };

  const handleClick = () => {
    amplitudeEvent('journey_filters_search_clicked');
  };

  useEffect(() => {
    debouncedApplyTextChange();
  }, [searchValue]);

  useEffect(() => {
    suspendDebounce();
    debounce(() => fetchJourneys({ page: 1 }));
  }, [searchContext]);

  return (
    <FuelTextField
      placeholder="Buscar motorista"
      style={{ marginRight: '16px' }}
      hasSuffix
      onKeyUp={(event) => handleKeyUp(event)}
      onClick={() => handleClick()}
      ref={searchInput}
      type="search"
      variant="small"
    >
      <FuelIcon slot="suffix" name="search" size="small" />
    </FuelTextField>
  );
}

export default FiltersSearch;
